// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__EtOj-","actions":"GroupTable_actions__3dIJT","deleteModalFooter":"GroupTable_deleteModalFooter__3C6u5"};